module.exports = __webpack_public_path__ + "static/img/pay-pt-btn.c1f46b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay/pay-pt-btn.png
// module id = DG/e
// module chunks = 1